<template>
  <div class="column is-4">
      <!-- <pre>{{$firebase.auth().currentUser.email}}</pre> -->
    <!-- <div class="column is-one-third"> -->
        <!-- <pre>{{page.continent}}</pre> -->
        <div class="card has-text-left">

<!-- <a v-if="page.image && page.image != '' && !page.image_placeholder" v-bind:href="page.url" target="_blank" class="column image-column is-one-third" :style="{ backgroundImage: `url(${page.image})`}"></a>
                <a v-if="!page.image || page.image == '' || page.image_placeholder" v-bind:href="page.url" target="_blank" class="column image-column is-one-third" :style="{ backgroundImage: `url(https://bikesleepbike.com/bsb_placeholder_dark.jpg)` }"></a> -->
                
            <div class="card-image">
                
                <div class="image-overlay" style="position:absolute; top: 0; left: 0; margin:5px; padding:5px; text-align:left;">
                    <p>
                     <span v-if="page.countries && page.countries.length > 0">
                        <b-tag
                            class="tag" style="font-size:14px" 
                            
                            type="is-white"
                            v-for="code in page.countries.concat().sort()"
                            v-bind:key = code
                            
                            > 
                            <span>{{$countrymap[code]}}</span>
                        </b-tag>
                    </span>
                    <span v-if="page.regions && page.regions.length > 0">
                        <b-tag
                            class="tag is-light" style="font-size:14px" 
                            v-for="region in page.regions.concat().sort()"
                            v-bind:key = region
                            
                            >
                            <span>{{region}}</span>
                        </b-tag>
                    </span>
                    </p>

                </div>    
                <!-- <a  target="_blank" rel="nofollow" @click="this.$buefy.modal.open({url: page.url})"> -->
                <a v-bind:href="page.url" target="_blank" rel="nofollow">
                <figure class="image is-16by9" >
                    <img :src="page.image" alt="Post thumbnail image" v-if="page.image && page.image != '' && !page.image_placeholder"  style="object-fit:cover">
                    <img src="https://bikesleepbike.com/bsb_placeholder_dark.jpg" alt="Placeholder thumbnail image" v-if="!page.image || page.image == '' || page.image_placeholder" style="object-fit:cover">
                    
                </figure>
                       
                </a>

                <div class="image-overlay" v-if="page.routes && page.routes.length > 0" style="position:absolute; bottom: 0; left: 0; padding:10px; margin:10px;  background-color:white; opacity:0.85;
                     border-radius:5px; color:black; text-align:left">
                        <div  class="small-label">Route</div>
                        <p class="title is-size-7">
                            <span
                                v-for="(route, idx) in page.routes.concat().sort()"
                                v-bind:key = route
                                >
                                <router-link :to="'/routes/' + route"><span>{{route}}</span></router-link><span v-if="idx != page.routes.length-1">, </span>
                            </span>
                        </p>


                </div>

              


            </div>
            <div class="card-content">
                <a v-bind:href="page.url" target="_blank" rel="nofollow" class="title is-size-5 has-text-left" style="display:block; margin-bottom:7px">{{page.title ? page.title : page.url}}</a>
                

                <div class="is-size-7">
                    <span  style="display:inline-block; margin-bottom: 7px; word-break: break-word">
                        Posted on <a target="_blank" re="nofollow" style="word-break: break-word;"
                        v-bind:href="page.url.split('://')[0] + '://' + page.url.split('://')[1].split('/')[0]" >{{page.site_name ? page.site_name : page.url.split('://')[1].split('/')[0]}}</a>
                        <span v-if="(showYear && page.year && page.year != '') || approveMode"> - {{page.year}}</span>
                    </span>
               
                
              <div v-if="page.description" class="is-size-7" style="margin-bottom: 15px; line-height:1.4em">{{truncateOnWord(page.description, 200)}}</div>
                 

              
                <!-- <div class="small-label">Style</div> -->
                <span v-if="(page.touring || page.bikepacking)">
                    <b-tag v-if="page.touring" class="tag is-light" >touring</b-tag>
                    <b-tag v-if="page.bikepacking" class="tag is-light" >bikepacking</b-tag>
                </span>
                <span v-if="(page.features && page.features.includes('racing'))">
                    <b-tag class="tag is-light" >racing</b-tag>
                </span>

                <!-- <br><br>
                <div class="small-label">Features</div> -->
                <span v-if="page.surfaces && page.surfaces.length > 0">
                    <b-tag
                        class="tag is-lightgray" 
                        v-for="surface in page.surfaces.concat().sort()"
                        v-bind:key = surface
                        >
                        {{surface}}
                    </b-tag>
                </span>
                
               
                 <span v-if="page.short || page.video || page.podcast || page.map" style="">
                        <b-tag v-if="page.short" class="tag is-primary">short trip</b-tag>
                        <b-tag v-if="page.map" class="tag is-primary">map</b-tag>
                        <b-tag v-if="page.video" class="tag is-primary">video</b-tag>
                        <b-tag v-if="page.podcast" class="tag is-primary">podcast</b-tag>
                    </span>
                <div>
                <span v-if="page.ridertags && page.ridertags.length > 0" class="small-label" style="display:inline-block; margin-top:15px">Rider tags: </span> 
               <span v-if="page.ridertags && page.ridertags.length > 0">
                    <router-link
                        class="is-size-7" 
                        v-for="(ridertag, idx) in page.ridertags.concat().sort()"
                        v-bind:key = ridertag
                        :to="'/ridertags/' + ridertag"
                        >
                        {{ridertag}}<span v-if="idx != page.ridertags.length - 1">,</span>
                    </router-link>
                    
                </span>
                </div>

                </div>
            </div>

            <!-- <b-modal v-model="isModalActive">
                <div>HI</div>
            </b-modal> -->


            <!-- <div class="card-footer">
                <a class="card-footer-item" :href="page.url" target="_blank" rel="nofollow" style="font-weight:bold">Read Post
                   
                </a>
            </div> -->
        </div>
    <!-- </div> -->
 </div>


</template>

<script>
// import CustomTagInput from '@/components/CustomTagInput';

export default {
  name: 'PageResultColumns',
  props: ["page", "showYear", "approveMode", "adminRequired"],
  data () {
    return {
        isModalActive: false,
        pageSrc: ""
        // admin mode
        // processed: false,
        // adminTitle: "",
        // adminImage: "",
        // adminYear: "",
        // adminRoutes: "",
        // adminRidertags: "",
        // adminPriority: ""
        // adminUrl: ""
    }
  },
  methods: {
      truncateOnWord(str, limit) {
            var trimmable = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';
            var reg = new RegExp('(?=[' + trimmable + '])');
            var words = str.split(reg);
            var count = 0;
            return words.filter(function(word) {
                count += word.length;
                return count <= limit;
            }).join('') + "...";
        },
        changeCountry(code) {
            // console.log(code);
            this.$getParent('FindTrip').setCountryInput(this.$countrymap[code]);
        },
        changeRoute(route) {
            // console.log(route);
            this.$getParent('FindTrip').setRouteInput(route);
        },
        changeSubregion(region) {
            // console.log(route);
            this.$getParent('FindTrip').setSubregionInput(region);
        },
       
   
        isAdmin() {
            return (this.$firebase.auth().currentUser.email == 'alissa.w.bell@gmail.com');
        }
  },
    mounted() {
        if (this.page.title && this.page.title != "") {
            this.adminTitle = this.page.title;
        }
        if (this.page.image && this.page.image != "") {
            this.adminImage = this.page.image;
        }
        // if (this.page.url && this.page.url != "") {
        //     this.adminUrl = this.page.url;
        // }
    }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .image-overlay {
        z-index: 100000;
    } 
    .image-overlay .tag {
        opacity: 1;
        text-transform: uppercase;
        /* font-size: 14px; */
        font-weight: bold;
        border:1px solid white;
    }

   /* .small-label {
       font-size:12px;
       color:#b5b5b5;
       display:block;
       text-transform:uppercase;
   } */

   .image-placeholder {
      position: absolute;
      background-image: url(https://bikesleepbike.com/bsb_placeholder.jpg);
      width:200px;
      height:100%;
      z-index: -1;
  } 
   .image-column {
        background-size: cover;
        background-position: 50%;
        min-height:200px;
    }
    .margin-bottom {
        margin-bottom:10px;
    }
    .tag {
        margin-right:3px;
        margin-bottom:3px;
    }
    .admin-buttons {
        position: absolute;
        bottom: 0;
        right: 0;
    }
    .tag.is-lightgray {
        background-color:#f3f2f2;
    }

</style>


<style >
    

</style>


// WEBPACK FOOTER //
// src/components/PageResultColumns.vue